export default __webpack_public_path__ + "0c882f069e1d3b28593c95ce79c67cf5.svg";